<script>
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    Nav,
    Footer
  }
};
</script>

<template>
  <div id="app" :lang="$i18n.locale">
    <Nav />
    <router-view />
    <Footer />
  </div>
</template>

<style lang="scss">
:root {
  --light-purple: rgba(83, 52, 245, 0.1);
  --dark-purple: rgba(71, 43, 182, 0.9);
}

body {
  margin: 0;
}
</style>
